import React, {Component} from "react";
import begin1a from '../../../../../assets/img/begin1a.png';
import begin2new from '../../../../../assets/img/begin2new.png';
import begin3new from '../../../../../assets/img/begin3new.png';
import begin4new from '../../../../../assets/img/begin4new.png';
import begin5new from '../../../../../assets/img/begin5new.png';
import begin6new from '../../../../../assets/img/begin6new.png';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import img1 from "../../../../../assets/img/kitcut-footer--pages-images/page2-1.png";
import img2 from "../../../../../assets/img/kitcut-footer--pages-images/page2-2.png";
import img3 from "../../../../../assets/img/kitcut-footer--pages-images/page2-3.png";
import img4 from "../../../../../assets/img/kitcut-footer--pages-images/page2-4.png";
import img5 from "../../../../../assets/img/kitcut-footer--pages-images/page2-5.png";
import img6 from "../../../../../assets/img/kitcut-footer--pages-images/page2-6.png";


class Page2 extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <div className="faq-page-layout">
                <div className="beginners-background-div footer-nav-pages-background">
                    <h3 className='font-size-30 yu-gothic-bold '>
                        Altium Designer ガーバーデータ出力方法
                    </h3>

                    <ol className="resp-ordered-list">

                        <p className=''>
                            {/*<p className='header20'>*/}
                            <li className='all-content-font-size'>
                                ファイル ＝＞ファブリケーション出力 ＝＞ガーバーファイルを選択します。
                            </li>
                        </p>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img1} alt=""/>
                        </p>

                        <br/>
                        <p className=''>
                            {/*<p className='header20'>*/}
                            <li className='all-content-font-size'>
                                <b> 一般設定</b>
                            </li>
                        </p>
                        <p className='all-content-font-size'>
                            一般設定で、精度を2：5（0.01ミル分解能）に設定します。

                        </p>

                        <p className=''>
                            {/*<p className='header20'>*/}
                            <li className='all-content-font-size'>
                                <b> レイヤー設定</b>
                            </li>
                        </p>
                        <p className='all-content-font-size'>
                            メカニカルレイヤーに明確な輪郭があることを確認してください。
                            <br/>
                            ボードが2層の場合、内層はありません（G1、G2、G3 ...）。
                            <br/>
                            これらをチェックして出力したいレイヤを含め、Plot Layersの“ Used On”を選択し、Mirror Layersの“ All Off”を選択します。
                        </p>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img2} alt=""/>
                        </p>
                        <br/>

                        <p className=''>
                            {/*<p className='header20'>*/}
                            <li className='all-content-font-size'>
                                <b> 絞り設定</b>
                            </li>
                        </p>
                        <p className='all-content-font-size'>
                            必ず「埋め込みアパーチャ（RS274X）」にチェックを付けてください。

                        </p>

                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img3} alt=""/>
                        </p>
                        <br/>

                        <p className=''>
                            {/*<p className='header20'>*/}
                            <li className='all-content-font-size'>
                                <b> 詳細設定</b>
                            </li>
                        </p>
                        <p className='all-content-font-size'>
                            すべての設定が問題ないことを確認したら。[OK]をクリックしてガーバーファイルを作成してください。

                        </p>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img4} alt=""/>
                        </p>
                        <br/>

                        <p className='all-content-font-size'>
                            ガーバーファイルは自動的にAltium cam viewerに読み込まれます。
                            <br/>
                            このツールを使用すると、すべてのレイヤが正しく作成されたこと、およびすべてがポジティブモードになっていることを確認できます。
                        </p>
                        <ol className="resp-ordered-list">
                            <p className='all-content-font-size'>
                                <b className="font-size-page2-20">NCドリルファイルの作成</b>
                                <li>
                                    <b> Excellonフォーマットで穴あけレイヤを作成します。</b>
                                </li>
                                <p className='all-content-font-size'>
                                    ファイル - >製造出力 ＝＞ NCドリルファイル

                                </p>
                            </p>

                            <p className='all-content-font-size '>
                                <img className="img-size-footer-nav resp-footer-nav-img" src={img5} alt=""/>
                            </p>
                            <br/>

                            <p>
                                <li className='all-content-font-size'>
                                    ガーバーと同じ単位とフォーマットパラメータを選択することをお勧めします。次に <b>[ OK ]</b> をクリックします。

                                </li>
                            </p>
                            <p className='all-content-font-size '>
                                <img className="img-size-footer-nav resp-footer-nav-img" src={img6} alt=""/>
                            </p>
                            <br/>

                        </ol>


                        <p className='all-content-font-size'>
                            各ガーバーファイルを作成したら、必ずGerberビューアーを使用して
                            、問題がないことを確認してください。
                            <br/>
                            それらのファイルを圧縮してKITCUT PCB注文ページにアップロードします。
                        </p>


                        {/*Altiumでファイルを作成するためのガイドを下記にて公開されています。*/}

                        {/*https://gs.altium.com/index.php?keys=NC%E3%83%89%E3%83%AA%E3%83%AB&submit=Search&q=gcs&lr=lang_ja&type=all*/}

                        {/*ALTIUM DESIGNERでPCBのドリルサイズをカスタマイズ*/}

                        {/*https://www.altium.com/jp/solution/pcb-drill-sizes*/}

                        {/*最高クラスのガーバーソフトウェア ビューアー*/}

                        {/*https://www.altium.com/jp/solution/pcb-gerber-viewer*/}


                    </ol>

                </div>
            </div>
        );
    }
}

export default Page2;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/FooterNavPages/page2.js